module.exports = __webpack_public_path__ + "static/media/shady.55c0f108.png";